import React, { FC } from 'react';
import { NavigationTemplate } from '../../NavigationTemplate';
import { GameDetailsContent } from './GameDetailsContent';

export const GameDetailsPage: FC = (): JSX.Element => {
  return (
    <NavigationTemplate>
      <GameDetailsContent />
    </NavigationTemplate>
  );
};
